

function showMapLocation(locationHandle) {
    const location = carParksMeta.find(loc => loc.locationHandle === locationHandle);

    /* console.log(location); */
    if (location) {

        const markerElement = document.querySelector(`[data-map-id="${locationHandle}"]`);
        console.log(markerElement);
        if (markerElement) {
            google.maps.event.trigger(markerElement, 'click');
        } else {
            console.error(`Marker with data-map-id="${locationHandle}" not found.`);    
        }
    }
}

window.showMapLocation = showMapLocation;

function initMap() {
    if (typeof carParksMeta === 'undefined' || !carParksMeta || carParksMeta.length === 0) {
        return;
    }
    const latitudes = carParksMeta.map(location => location.locationLat).filter(lat => lat !== null);
    const longitudes = carParksMeta.map(location => location.locationLng).filter(lng => lng !== null);

    const lat_min = Math.min(...latitudes);
    const lat_max = Math.max(...latitudes);
    const lng_min = Math.min(...longitudes);
    const lng_max = Math.max(...longitudes);

    const mapOptions = {
        zoom: carParksMeta.length > 1 ? 10 : 18,
        center: {
            lat: carParksMeta.length > 1 ? ((lat_max + lat_min) / 2.0) : (carParksMeta[0]?.locationLat || 0),
            lng: carParksMeta.length > 1 ? ((lng_max + lng_min) / 2.0) : (carParksMeta[0]?.locationLng || 0)
        },
        mapId: 'map',
        mapSidebarType: 'list',
        mapLinks: true,
        MapTypeId: 'roadmap',
    };

    const map = new google.maps.Map(document.getElementById('map'), mapOptions);
    var bounds = new google.maps.LatLngBounds();
    if (carParksMeta.length > 1) {
        bounds = new google.maps.LatLngBounds(
            new google.maps.LatLng(lat_min, lng_min), // bottom left
            new google.maps.LatLng(lat_max, lng_max)  // top right
        );


        map.fitBounds(bounds);
    }

    var infowindow = new google.maps.InfoWindow();

    carParksMeta.forEach((location, index) => {
        const markerElement = document.createElement('div');
        markerElement.className = 'custom-marker';
        markerElement.style.position = 'relative';
        markerElement.style.width = '36px';
        markerElement.style.height = '36px';

        // Create the marker icon
        const iconElement = document.createElement('div');
        if (location.showAvailable == true && location.availableRooms > 0 ) {
            iconElement.style.backgroundImage = `url(${location.locationMarkerIcon.available})`;
        } else {
            iconElement.style.backgroundImage = `url(${location.locationMarkerIcon.dark})`;
        }
        iconElement.style.width = '100%';
        iconElement.style.height = '100%';
        iconElement.style.backgroundSize = 'contain';
        iconElement.style.backgroundRepeat = 'no-repeat';

        const numberLabel = document.createElement('div');
        numberLabel.className = 'marker-number';
        numberLabel.style.position = 'absolute';
        numberLabel.style.top = '-10px';
        numberLabel.style.left = '50%';
        numberLabel.style.transform = 'translateX(-50%)';
        numberLabel.style.backgroundColor = '#fff';
        numberLabel.style.color = '#000';
        numberLabel.style.borderRadius = '50%';
        numberLabel.style.padding = '2px 6px';
        numberLabel.style.fontSize = '12px';
        numberLabel.style.fontWeight = 'bold';
        numberLabel.style.boxShadow = '0 0 2px rgba(0, 0, 0, 0.5)';
        numberLabel.textContent = index + 1; // Display the index as the number

        // Append the icon and number label to the marker element
        markerElement.appendChild(iconElement);
        markerElement.appendChild(numberLabel);

        // Create an AdvancedMarkerElement
        const advancedMarker = new google.maps.marker.AdvancedMarkerElement({
            position: { lat: location.locationLat, lng: location.locationLng },
            map: map,
            title: location.locationName,
            content: markerElement
        });

        // Add custom attributes to the marker element
        advancedMarker.setAttribute('data-map-id', location.locationHandle);
        

        // New logic on Aged-home 
        if (location.showAvailable != true) {
            location.availableRooms
        }
        // Add click event listener for each marker
        google.maps.event.addListener(advancedMarker, 'click', () => {
            infowindow.setContent(`
                <div class="o-info-window__container">
                    <div class="o-info-window__content">
                    
                        <div class="o-info-window__item">
                            <img src="${location.locationImage}" alt="Single image of ${location.locationName}" style="max-width: 150px;">      
                        </div>

                        <div class="o-info-window__title">
                            <a href="${location.locationUrl}" class="o-info-window__link" tabindex="0" role="link" style="text-decoration:underline;">${location.locationName}</a>
                        </div>
                        
                        <div class="o-info-window__item">${location.locationAddress}</div>
                        ${location.showAvailable === true ?
                            `
                            <div class="o-info-window__item" style="font-weight: 700;">
                                ${location.availableRooms} ${location.availableRooms == 1 ? 'Property Available' : 'Properties Available'}
                            </div>` 
                            : ''}
                        
                    </div>
                </div>
            `);  
            infowindow.open(map, advancedMarker);

            // Smooth zoom in to level 16 when a marker is clicked
            
            map.panTo({ lat: location.locationLat, lng: location.locationLng });
            if (window.innerWidth >= 768) {
                smoothZoom(map, 12, map.getZoom());
            } else {
                map.setZoom(12);
            }  
        });
    });

    // Add listener to reset zoom level when infowindow is closed
    google.maps.event.addListener(infowindow, 'closeclick', () => {
        // smoothZoom(map, 10, map.getZoom());
        map.fitBounds(bounds);
    });
}

// Smooth zoom function
function smoothZoom(map, targetZoom, currentZoom) {
    if (currentZoom === targetZoom) return;
    const step = targetZoom > currentZoom ? 1 : -1;
    google.maps.event.addListenerOnce(map, 'zoom_changed', () => {
        smoothZoom(map, targetZoom, currentZoom + step);
    });
    setTimeout(() => map.setZoom(currentZoom + step), 200);
}
window.smoothZoom = smoothZoom;
// Load Google Maps script dynamically


document.addEventListener("DOMContentLoaded", function () {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${maps_api}&libraries=marker`;
    script.async = true;
    script.onload = initMap; // Ensure initMap is called after the script loads
    document.head.appendChild(script);

    /* initMap(); */
});